import { getCountry, getMerchant } from '@tectonics/prs/incoming-payment';
import type { IncomingPayment } from '@tectonics/prs/incoming-payment';
import { getPublicIntegrationKey, getLookAndFeel } from '@tectonics/prs/merchant';

export type GA4EventParams = Record<string, unknown>;

export interface CommonGA4EventParams {
  readonly merchant_id: string;
  readonly checkout_country: string;
  readonly payment_method: string;
  readonly environment: string;
  readonly checkout_version: string;
  readonly look_and_feel: string;
}

export function sendGA4Event(eventName: string, eventParams: GA4EventParams = {}): boolean {
  try {
    if (typeof window.gtag !== 'function') return false;
    window.gtag('event', eventName, eventParams);
    return true;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('GA4 sendGA4Event error:', e);
    return false;
  }
}

export function buildCommonEventParams(payment: IncomingPayment): Partial<CommonGA4EventParams> {
  try {
    const merchant = getMerchant(payment);

    return {
      merchant_id: getPublicIntegrationKey(merchant),
      checkout_country: getCountry(payment),
      payment_method: payment.payment_type_code || '',
      environment: ENV_CONSTANTS.ENV,
      checkout_version: typeof COMMITHASH === 'string' ? COMMITHASH : '',
      look_and_feel: getLookAndFeel(merchant),
    };
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('GA4 buildCommonEventParams error:', e);
    return {};
  }
}
